<script lang="ts">
	import { onMount } from 'svelte';

	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import '@splidejs/svelte-splide/css';
	export let data: any = [];
	$: items = data;
	let splideRef: { go: (arg0: string) => void };
	let splideRefRoom: { go: (arg0: string) => void };

	function goNext() {
		splideRef.go('>');
	}

	function goPrev() {
		splideRef.go('<');
	}
	function goRoomNext() {
		splideRefRoom.go('>');
	}

	function goRoomPrev() {
		splideRefRoom.go('<');
	}
</script>

<div class="lg:grid lg:grid-cols-7 pt-10 lg:pt-32">
	<div class="lg:col-span-3 px-5 lg:px-16">
		<div class="hidden lg:block">
			<h2 class="gilda font-medium text-[#41818A] text-2xl lg:text-5xl">
				Spa<br />Treatment
			</h2>
			<p class="my-3 text-[#7A7A7A]">
				Indulge in rejuvenating spa treatments that harmonize mind and body. Experience the perfect
				blend of luxury and relaxation designed to elevate your well-being.
			</p>
		</div>
		<div class="block lg:hidden">
			<h2 class="gilda font-medium text-[#41818A] text-6xl">
				Spa<br />Treatment
			</h2>
		</div>
		<div class="flex mb-5 lg:mb-0 mt-4 gap-5">
			<!-- Previous Button -->
			<button
				class="flex items-center justify-center rounded-full focus:outline-none"
				on:click={goPrev}
				aria-label="Previous Slide"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="84"
					height="84"
					viewBox="0 0 84 84"
					fill="none"
				>
					<rect x="0.5" y="0.5" width="83" height="83" rx="41.5" stroke="#41818A" />
					<path d="M48 54L36 42L48 30" stroke="#41818A" stroke-width="2" />
				</svg>
			</button>

			<!-- Next Button -->
			<button
				class="flex items-center justify-center rounded-full focus:outline-none"
				on:click={goNext}
				aria-label="Next Slide"
			>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="84"
					height="84"
					viewBox="0 0 84 84"
					fill="none"
				>
					<rect x="0.5" y="0.5" width="83" height="83" rx="41.5" stroke="#41818A" />
					<path d="M36 30L48 42L36 54" stroke="#41818A" stroke-width="2" />
				</svg>
			</button>
		</div>
	</div>
	<div class="lg:col-span-4">
		<div id="destination-card" class="2xl:container 2xl:mx-auto mx-5 lg:mx-0">
			<Splide
				bind:this={splideRef}
				options={{
					rewind: false,
					gap: 5,
					padding: { right: '15%', left: '0%' },
					perPage: 2,
					type: 'loop',
					arrows: false,
					pagination: false,
					breakpoints: {
						1024: {
							perPage: 2,
							gap: 10,
							padding: { right: '15%', left: '0%' }
						},
						768: {
							perPage: 2,
							gap: 10,
							padding: { right: '0%', left: '0%' }
						},
						480: {
							perPage: 1,
							gap: 10,
							padding: { right: '0%', left: '0%' }
						}
					}
				}}
			>
				{#each items?.item as item}
					<SplideSlide>
						<div class="hidden lg:block">
							<div class="relative group" style="aspect-ratio: 3/5; overflow: hidden;">
								<img
									src="https://sohamwellnesscenter.com/sohamCMS/storage/app/media/{item?.images}"
									alt={item?.title}
									class="w-full h-full object-cover transition-transform duration-300 ease-in-out group-hover:scale-105"
								/>

								<div
									class="absolute bottom-0 h-full w-full"
									style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.00) 100%);"
								></div>

								<div class="absolute bottom-10 px-10">
									<h1 class="text-white text-2xl gilda">{item?.title}</h1>
									<div class="line-clamp-3 text-white text-xs my-2">
										{@html item?.description}
									</div>
									<a
										href="/wellness/{items?.slug}"
										class="relative text-white mt-5 mb-1 uppercase transition-all duration-300 ease-in-out"
									>
										Explore

										<span
											class="absolute left-0 bottom-[-2%] w-3/4 h-[1px] bg-white group-hover:w-full transition-all duration-300 ease-in-out"
										></span>
									</a>
								</div>
							</div>
						</div>
						<div class="block lg:hidden group">
							<div class="aspect-square">
								<img
									src="https://sohamwellnesscenter.com/sohamCMS/storage/app/media/{item?.images}"
									alt={item?.title}
									class="w-full h-full object-cover"
								/>
							</div>
							<div class="my-2">
								<h1 class="text-[#41818A] text-3xl gilda">{item?.title}</h1>
								<a
									href="/wellness/{items?.slug}"
									class="relative text-[#41818A] mt-5 mb-1 uppercase transition-all duration-300 ease-in-out group-hover:text-[#41818A]"
								>
									Explore

									<span
										class="absolute left-0 bottom-0 w-3/4 h-[1px] bg-[#41818A] group-hover:w-full group-hover:bg-[#41818A] transition-all duration-300 ease-in-out"
									></span>
								</a>
							</div>
						</div>
					</SplideSlide>
				{/each}
			</Splide>
		</div>
	</div>
</div>
